module.exports = __webpack_public_path__ + "static/img/game6.17c67ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game6.jpg
// module id = Bh2r
// module chunks = 1